import { render } from "./ProductOptionsTable.vue?vue&type=template&id=7fa5f23e&scoped=true"
import script from "./ProductOptionsTable.vue?vue&type=script&lang=js"
export * from "./ProductOptionsTable.vue?vue&type=script&lang=js"

import "./ProductOptionsTable.vue?vue&type=style&index=0&id=7fa5f23e&scoped=true&lang=scss"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa5f23e"]])

export default __exports__